import './Settings.scss'
import React from 'react'
import AccountSetting from './AccountSetting'
// import UsersSetting from './UsersSetting'

import { useAppDispatch, useAppSelector } from '../../hooks/useReduxToolkit'
import { setSettingTab } from '../../core/store/setting/settingslice'

import { ReactComponent as AccountIcon } from '../../icons/account.svg'
import { ReactComponent as DollarIcon } from '../../icons/dollar.svg'

export default function Settings (): React.ReactElement {
  const dispatch = useAppDispatch()
  const tab = useAppSelector((s) => s.settings.settingTab)

  const Menu = [
    {
      label: 'Account',
      icon: <AccountIcon />,
      component: <AccountSetting />
    }
    // {
    //   label: 'Users',
    //   icon: <AccountIcon />,
    //   component: <UsersSetting />
  ]

  return (
    <div className="container-settings">
      <div className='container settings py-5'>
        <div className="setting-menu">
          <h5>Settings</h5>
          <ul>
            {
              Menu.map((item, i) =>
                <li
                  key={item.label + String(i)}
                  className={i === tab ? 'active' : ''}
                  onClick={() => { dispatch(setSettingTab(i)) }}
                >
                  {item.icon}{item.label}
                </li>
              )
            }
          </ul>
        </div>
        <div className="setting-content">
          <div style={{ marginBottom: 50 }}>
            <h5 className="subtitle">Settings</h5>
            <h3 className="title">{Menu[tab].label}</h3>
          </div>
          {
            Menu[tab].component
          }
        </div>
        {/* <div className="setting-right"></div> */}
      </div>
    </div>
  )
}
